module.exports = __webpack_public_path__ + "assets/img/zephry_back.ed3da333.svg";